<template>
  <div class="pc-university">
    <BreadCrumb :data="breadcrumb" :title="'学者列表管理'" />
    <MagazineScholarTable />
  </div>
</template>
<script>
// 功能模块
import BreadCrumb from "../../componentSet/BreadCrumb";
import MagazineScholarTable from "./components/MagazineScholarTable";
import {
} from "@/apis/scholar.api";
export default {
  components: {
    BreadCrumb,
    MagazineScholarTable,
  },
  data() {
    return {
    };
  },
  computed: {
    breadcrumb: function () {
      return [
        { name: "首页", link: "/admin/main" },
        { name: "学者列表", link: "/admin/magazineScholarList" },
      ];
    },
  },
  mounted() {

  },
  methods: {
  }
};
</script>
<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/admin/guihua/MagazineScholarList.vue